"use client";
import { usePathname } from "next/navigation";
import { PLANNING_PAGES } from "@/lib/planning/catalog";

/** Keep the established site copy everywhere else. The free toolkit has its
 * own plain description, passed from the server's English message file. */
export function PlanningFooterDescription({ original, planning }: { original: string; planning: string }) {
  const path = usePathname();
  return path === "/tools" || PLANNING_PAGES.some((page) => page.path === path) ? planning : original;
}
